import styled from 'styled-components';
import { Typography, Box, Paper, Container } from '@mui/material';
import { COLORS } from 'helpers/enums/colors';

export const StyledLandingContainer = styled(Container)`
  && {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`;

export const HeroSection = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 80px 20px;
  background: linear-gradient(135deg, #0057ff 0%, #003db3 100%);
  color: white;
  border-radius: 20px;
  margin-bottom: 48px;
  box-shadow: 0 10px 30px rgba(0, 87, 255, 0.2);
`;

export const HeroTitle = styled(Typography)`
  && {
    font-weight: 800;
    font-size: 3.5rem;
    margin-bottom: 16px;
    letter-spacing: -1px;

    @media (max-width: 600px) {
      font-size: 2.5rem;
    }
  }
`;

export const HeroSubtitle = styled(Typography)`
  && {
    font-weight: 400;
    max-width: 600px;
    opacity: 0.9;
  }
`;

export const SectionTitle = styled(Typography)`
  && {
    font-weight: 700;
    color: ${COLORS.grayScorpion || '#555'};
    margin-bottom: 24px;
    position: relative;
    display: inline-block;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -4px;
      width: 40px;
      height: 4px;
      background-color: #0057ff;
      border-radius: 2px;
    }
  }
`;

export const InfoCard = styled(Paper)`
  && {
    padding: 32px;
    height: 100%;
    border-radius: 16px;
    background-color: #ffffff;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border: 1px solid #f0f0f0;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
    }
  }
`;

export const ContactWrapper = styled(Box)`
  padding: 24px;
  background-color: #f8f9fa;
  border-radius: 16px;
  border: 1px dashed #dee2e6;
`;

export const DecorationBox = styled(Box)`
  color: #0057ff;
  font-size: 40px;
  margin-bottom: 16px;
`;
